import React from "react";
import { Reveal, Overline } from "./primitives";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { FAQS } from "../../data/content";

export default function FAQSection() {
  return (
    <section className="relative bg-white py-20 sm:py-28" data-testid="section-faq">
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-12 px-5 sm:px-8 lg:grid-cols-12">
        <div className="lg:col-span-4">
          <Reveal>
            <Overline>FAQ</Overline>
            <h2 className="mt-4 font-heading text-4xl font-extrabold tracking-tight text-ajmus-ink sm:text-5xl">
              Questions, answered.
            </h2>
            <p className="mt-5 text-base leading-relaxed text-ajmus-steel">
              Everything you need to know about adopting AJMUS across your organisation.
            </p>
          </Reveal>
        </div>

        <div className="lg:col-span-8">
          <Reveal delay={0.1}>
            <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
              {FAQS.map((f, i) => (
                <AccordionItem key={i} value={`item-${i}`} className="border-b border-black/8">
                  <AccordionTrigger
                    data-testid={`faq-trigger-${i}`}
                    className="py-5 text-left font-heading text-lg font-bold tracking-tight text-ajmus-ink hover:no-underline"
                  >
                    {f.q}
                  </AccordionTrigger>
                  <AccordionContent className="pb-5 text-[15px] leading-relaxed text-ajmus-steel">
                    {f.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
